import axios from 'axios';

export function getCustomerLabels() {
    return axios.get('/api/warehousing/customer');
}

export function getCustomer(customerId) {
    return axios.get(`/api/warehousing/customer/${customerId}`);
}

export function updateCustomer(customer) {
    return axios.put(`/api/warehousing/customer/${customer.customerId}`, customer);
}

export function createCustomer(customer) {
    return axios.post('/api/warehousing/customer', customer);
}

export function deleteCustomer(customerId) {
    return axios.delete(`/api/warehousing/customer/${customerId}`);
}

export function getInvoiceLogicTypes() {
    return axios.get('api/warehousing/enum/invoiceLogicType');
}

export function getArticleGroupsTypes() {
    return axios.get('api/warehousing/enum/articleGroupsType');
}

export function getAllCustomerExport(fromDate, toDate) {
    return axios.get('/api/warehousing/customer/export-all', {
        params: {
            from: fromDate,
            to: toDate,
        },
        responseType: 'blob',
    });
}

export function getCustomerDataExport(fromDate, toDate, customerId) {
    return axios.get(`/api/warehousing/customer/${customerId}/export`, {
        params: {
            from: fromDate,
            to: toDate,
        },
        responseType: 'blob',
    });
}
